export default __webpack_public_path__ + "static/logo_lotus-0a0ea0574494a18ad8dbaf2d48253ef6.png";